module.exports = __webpack_public_path__ + "img/Logo_Hor_Mozza.6da030ba.png";